import { ServerOfferStatus } from '@yoop/server-model/token-info';

/**
 * Predicate for pending result offers (after marketplace has ended)
 * @param offer
 */
export const pendingResult: (offer: { offerStatus?: ServerOfferStatus }) => boolean = (offer: {
  offerStatus?: ServerOfferStatus;
}): boolean =>
  offer &&
  (offer.offerStatus === ServerOfferStatus.DEFAULT ||
    offer.offerStatus === ServerOfferStatus.WON_PAYMENT_PROCESSING_PENDING);
